<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Facility Classification
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="theme"
                :label="this.localForm.theme"
                :items="facilityThemeOptions"
                color="wplblue0"
                prepend-icon="grid_view"
                hint="theme"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="type"
                :label="this.localForm.type"
                :items="facilityTypeOptions"
                color="wplblue0"
                prepend-icon="factory"
                hint="type"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="own"
                :label="this.localForm.own"
                :items="businessOwnershipOptions"
                color="wplblue0"
                prepend-icon="store"
                hint="ownership"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="manage"
                :label="this.localForm.manage"
                :items="facilityStructure"
                color="wplblue0"
                prepend-icon="account_tree"
                hint="manage."
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="loc"
                :label="this.localForm.loc"
                :items="facilityLocation"
                color="wplblue0"
                prepend-icon="schedule"
                hint="location"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="site"
                :label="this.localForm.site"
                :items="siteInductionOptions"
                color="wplblue0"
                prepend-icon="login"
                hint="site access"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="risk"
                :label="this.localForm.risk"
                :items="riskOpsOptions"
                color="wplblue0"
                prepend-icon="priority_high"
                hint="ops. risk"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="out"
                :label="this.localForm.out"
                :items="businessOutputOptions"
                color="wplblue0"
                prepend-icon="warehouse"
                hint="facility output"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="reg"
                :label="this.localForm.reg"
                :items="businessRegulationOptions"
                color="wplblue0"
                prepend-icon="verified_user"
                hint="regulation"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="work"
                :label="this.localForm.work"
                :items="workPermitOptions"
                color="wplblue0"
                prepend-icon="work_outline"
                hint="work permit"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Facility Description
            </div>
          </v-layout>
          <v-layout row wrap class="ml-3 mr-2 mt-2">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.des"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              hint="facility description"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import incidentOptions from "@/data/options/mixins/incidentOptions.js";
import riskOptions from "@/data/options/mixins/riskOptions.js";
import safetyOptions from "@/data/options/mixins/safetyOptions.js";
import facilityOptions from "@/data/options/mixins/facilityOptions.js";
import workOptions from "@/data/options/mixins/workOptions.js";
import businessOptions from "@/data/options/mixins/businessOptions.js";
import disciplineOptions from "@/data/options/mixins/disciplineOptions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        loc: "",
        type: "",
        manage: "",
        site: "",
        des: "",
        reg: "",
        risk: "",
        out: "",
        work: "",
        own: "",
        theme: ""
      },
      orgForm: {
        loc: "",
        type: "",
        manage: "",
        site: "",
        des: "",
        reg: "",
        risk: "",
        out: "",
        work: "",
        own: "",
        theme: ""
      },
      type: "",
      site: "",
      loc: "",
      manage: "",
      out: "",
      risk: "",
      work: "",
      reg: "",
      own: "",
      theme: ""
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.manage = this.getDetail.char.manage;
    this.localForm.site = this.getDetail.char.site;
    this.localForm.loc = this.getDetail.char.loc;
    this.localForm.type = this.getDetail.char.type;
    this.localForm.des = this.getDetail.char.des;
    this.localForm.risk = this.getDetail.char.risk;
    this.localForm.reg = this.getDetail.char.reg;
    this.localForm.work = this.getDetail.char.work;
    this.localForm.own = this.getDetail.char.own;
    this.localForm.out = this.getDetail.char.out;
    this.localForm.theme = this.getDetail.char.theme;

    this.orgForm.type = this.getDetail.char.type;
    this.orgForm.site = this.getDetail.char.site;
    this.orgForm.loc = this.getDetail.char.loc;
    this.orgForm.manage = this.getDetail.char.manage;
    this.orgForm.des = this.getDetail.char.des;
    this.orgForm.risk = this.getDetail.char.risk;
    this.orgForm.reg = this.getDetail.char.reg;
    this.orgForm.work = this.getDetail.char.work;
    this.orgForm.own = this.getDetail.char.own;
    this.orgForm.out = this.getDetail.char.out;
    this.orgForm.theme = this.getDetail.char.theme;
  },
  watch: {
    site() {
      this.localForm.site = this.site;
      this.updateFormChar();
    },
    loc() {
      this.localForm.loc = this.loc;
      this.updateFormChar();
    },
    manage() {
      this.localForm.manage = this.manage;
      this.updateFormChar();
    },
    type() {
      this.localForm.type = this.type;
      this.updateFormChar();
    },
    risk() {
      this.localForm.risk = this.risk;
      this.updateFormChar();
    },
    reg() {
      this.localForm.reg = this.reg;
      this.updateFormChar();
    },
    work() {
      this.localForm.work = this.work;
      this.updateFormChar();
    },
    own() {
      this.localForm.own = this.own;
      this.updateFormChar();
    },
    theme() {
      this.localForm.theme = this.theme;
      this.updateFormChar();
    },
    out() {
      this.localForm.out = this.out;
      this.updateFormChar();
    }
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    incidentOptions,
    disciplineOptions,
    riskOptions,
    businessOptions,
    workOptions,
    safetyOptions,
    facilityOptions
  ],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar", "getCurrentPage"])
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.manage !== this.orgForm.manage &&
        this.localForm.manage !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.manage = this.localForm.manage;
        // basic
        char.manage = this.localForm.manage;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.loc !== this.orgForm.loc &&
        this.localForm.loc !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.loc = this.localForm.loc;
        // basic
        char.loc = this.localForm.loc;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.type !== this.orgForm.type &&
        this.localForm.type !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.type = this.localForm.type;
        // basic
        char.type = this.localForm.type;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.site !== this.orgForm.site &&
        this.localForm.site !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.site = this.localForm.site;
        // basic
        char.site = this.localForm.site;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.risk !== this.orgForm.risk &&
        this.localForm.risk !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.risk = this.localForm.risk;
        // basic
        char.risk = this.localForm.risk;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.reg !== this.orgForm.reg &&
        this.localForm.reg !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.reg = this.localForm.reg;
        // basic
        char.reg = this.localForm.reg;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.work !== this.orgForm.work &&
        this.localForm.work !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.work = this.localForm.work;
        // basic
        char.work = this.localForm.work;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.des !== this.orgForm.des &&
        this.localForm.des !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.des = this.localForm.des;
        // basic
        char.des = this.localForm.des;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.own !== this.orgForm.own &&
        this.localForm.own !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.own = this.localForm.own;
        // basic
        char.own = this.localForm.own;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 9); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.theme !== this.orgForm.theme &&
        this.localForm.theme !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.theme = this.localForm.theme;
        // basic
        char.theme = this.localForm.theme;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 10); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.out !== this.orgForm.out &&
        this.localForm.out !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.out = this.localForm.out;
        // basic
        char.out = this.localForm.out;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 11); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
